import { StreamChat } from 'stream-chat';

const chatClient = StreamChat.getInstance(
  process.env.REACT_APP_STREAMIO_API_KEY ?? ''
);

export default chatClient;
